import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=0bdec163&scoped=true&"
import script from "./Question.vue?vue&type=script&lang=js&"
export * from "./Question.vue?vue&type=script&lang=js&"
import style0 from "./Question.vue?vue&type=style&index=0&id=0bdec163&scoped=true&lang=css&"
import style1 from "@/assets/css/font.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/content.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdec163",
  null
  
)

export default component.exports